import {
  Button,
  CardMedia,
  Checkbox,
  Paper,
  Typography
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React, {
  useCallback,
  useContext,
  useRef,
  useState
} from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ReactToPrint from "react-to-print";
import HttpClient from "../../api/HttpClient";
import { useGlobalData } from "../../constant/GlobalDataContext";
import { useLoading } from "../../constant/LoadingContext";
import { SnackbarContext } from "../../constant/SnackbarProvider";
import DocumentTemplate from "./DocTemplate";

type DocumentListsProps = {
  docLists: any[];
  setDocContent: (docContent: any) => void;
  setShowStatus: (showStatus: "list" | "document") => void;
  allSigned: boolean;
  docSignatureWatch: any;
  setOpenConfirmModal?: (openConfirmModal: boolean) => void;
  readonly?: boolean;
  _staffData?: any;
};

const DocumentLists = (props: DocumentListsProps) => {
  const { docSignatureWatch, setOpenConfirmModal, readonly, _staffData } = props;
  const classes = useStyles();
  const [docLists, setDocLists] = useState(props?.docLists || []);
  const printRef = useRef<HTMLDivElement>(null);
  const [checkedList, setCheckedList] = useState<number[]>([]);
  const { setLoading } = useLoading();
  const Snackbar = useContext(SnackbarContext);
  const location = useLocation();

  const HandleSendEmail = async () => {
    setLoading(true);
    await HttpClient().HandleSendEmailApi(
      {
        printComponentRef: printRef,
        personalRef: null,
        handBookRef: null,
        email: _staffData?.email,
        area: _staffData?.area,
        subject: "員工入職文件",
        isFromStaff: false,
      },
      () => {
        Snackbar.open({
          alertProps: { severity: "success" },
          message: "電郵傳送文件成功!",
        });
        setLoading(false);
      },
      (error) => {
        Snackbar.open({
          alertProps: { severity: "error" },
          message: "電郵傳送文件失敗 " + error,
        });
        setLoading(false);
      }
    );
  }

  const HandleAllSelect = (event) => {
    setCheckedList(
      (prev) =>
        prev.length === docLists.length
          ? [] // deselect all
          : docLists.map((_, index) => index) // select all
    );
  };

  const HandleSpecificChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>, index: number) => {
      setCheckedList((prev) =>
        prev.includes(index)
          ? prev.filter((i) => i !== index)
          : [...prev, index]
      );
    },
    []
  );

  const ConvertQtyToWord = (qty: number) => {
    if (qty === 1) return " 一 ";
    if (qty === 2) return " 二 ";
    if (qty === 3) return " 三 ";
    if (qty === 4) return " 四 ";
    return "";
  };

  const ConvertTitle = (title: string) => {
    if (title === "reference_authorization")
      return "Reference Check Authorization授權書";
    if (title === "personal_information")
      return "個人資料(指紋及面部圖像)收集同意書";
    if (title === "handbook") return "《員工手冊》簽收紀錄";
    return "";
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Paper
        style={{
          width: "80%",
          padding: "50px 20px",
          marginTop: "30px",
          borderRadius: "2rem",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        <div
          style={{
            paddingTop: "0",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <div>
            {readonly && (
              <Button
                variant="contained"
                color="primary"
                onClick={(e) => {
                  HandleAllSelect(e);
                }}
                style={{
                  backgroundColor: "#908DF2",
                }}
              >
                {checkedList.length === docLists.length ? "取消全選" : "全選"}
              </Button>
            )}
            {docLists.length > 0 &&
              docLists?.map((item: any, index: number) => {
                return (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {readonly && (
                      <Checkbox
                        checked={checkedList.includes(index)}
                        onChange={(e) => HandleSpecificChange(e, index)}
                        className={classes.checkbox}
                      />
                    )}
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                      }}
                      key={index}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                        }}
                      >
                        <Typography
                          style={{ padding: "15px 0", color: "#84909F" }}
                        >
                          {`文件${ConvertQtyToWord(index + 1)}`}
                        </Typography>
                        <div
                          className={classes.pinkTitleContent}
                          style={{ marginLeft: 0 }}
                          onClick={() => {
                            props?.setDocContent(item);
                            props?.setShowStatus("document");
                          }}
                        >
                          <Typography>
                            {ConvertTitle(item?.documentName)}
                          </Typography>
                          {(docSignatureWatch[item?.documentName]?.signature ||
                            false) && (
                            <CardMedia
                              component="img"
                              image={require("../../icons/blueTick.png")}
                              alt=""
                              className={classes.media}
                            />
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
          </div>
        </div>

        <>
          {!readonly ? (
            <>
              <div className={classes.hrConfirmBtnContainer}>
                <Typography style={{ padding: "1.5rem 0" }}>
                  {"HR檢查以上所有文件後，請按下面“完成”"}
                </Typography>
                <Button
                  disabled={!props?.allSigned}
                  variant="contained"
                  color={"primary"}
                  onClick={() => {
                   setOpenConfirmModal?.(true);
                  }}
                  className={classes.hrConfirmBtn}
                >
                  {"完成"}
                </Button>
              </div>
            </>
          ) : (
            <>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-around",
                  paddingTop: "2rem",
                }}
              >
                <div>
                  <ReactToPrint
                    trigger={() => (
                      <Button
                        disabled={!checkedList.length}
                        startIcon={
                          <CardMedia
                            component="img"
                            image={require("../../icons/print.png")}
                            alt=""
                            className={classes.printButtonMedia}
                          />
                        }
                        variant="contained"
                        color={"primary"}
                        className={classes.printButton}
                      >
                        {`列印 (${checkedList?.length || 0})`}
                      </Button>
                    )}
                    documentTitle={"已簽署文件"}
                    content={() => {
                      return printRef.current;
                    }}
                    onBeforeGetContent={() => {
                      Snackbar.open({
                        alertProps: { severity: "info" },
                        title: "員工入職文件",
                        message: "列印中...",
                      });
                      setTimeout(() => {
                        Snackbar.close();
                      }, 3000);
                    }}
                  />
                </div>
                <div>
                  <Button
                    disabled={!checkedList.length}
                    startIcon={
                      <CardMedia
                        component="img"
                        image={require("../../icons/sendEmail.png")}
                        alt=""
                        className={classes.printButtonMedia}
                      />
                    }
                    variant="contained"
                    color={"primary"}
                    // disabled={IsDisabled()}
                    onClick={() => {
                      HandleSendEmail();
                    }}
                    className={classes.leftButton}
                  >
                    {`電郵傳送文件 (${checkedList?.length || 0})`}
                  </Button>
                </div>
              </div>
            </>
          )}
        </>
      </Paper>
      <div style={{display: 'none'}}>
        <div ref={printRef}>
          {checkedList.sort((a, b) => a - b).map((item: any, index: number) => (
            <div key={index} className={index !== 0 ? 'pageBreak' : ''}>
              <DocumentTemplate
                docContent={docLists[item]}
                brand={docLists[item]?.brand}
                signature={docLists[item].signature}
                signatureDate={docLists[item]?.signatureDate}
                readonly={true}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default DocumentLists;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    height: "100vh",
  },
  title: { color: "#454C96", fontWeight: 500 },

  input: {
    margin: "2px 0px",
  },
  button: {
    margin: theme.spacing(1, 0),
  },
  editButton: {
    margin: theme.spacing(1, 0),
    backgroundColor: "#908DF2",
    height: "3rem",
  },
  media: {
    height: "20px",
    margin: "5px",
    [`&.MuiCardMedia-img`]: {
      objectFit: "contain",
      width: "20px",
    },
    position: "absolute",
    right: "5px",
    bottom: "7px",
  },
  arrow: {
    height: "20px",
    margin: "5px",
    [`&.MuiCardMedia-img`]: {
      objectFit: "contain",
      width: "20px",
    },
    paddingTop: "0.7rem",
    cursor: "pointer",
  },
  adornment: {},
  imageForm: {
    width: "8rem",
    height: "6rem",
    backgroundColor: "#F4EFFF",
    display: "flex",
    justifyContent: "center",
    borderRadius: "1rem",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "#454C96",
    },
    alignItems: "center",
    flexDirection: "column",
  },
  allSelect: {
    paddingRight: "3rem",
    color: "#908DF2",
  },
  greyTitle: {
    color: "#84909F",
  },
  pinkTitleContent: {
    margin: "0.3rem 0",
    position: "relative",
    backgroundColor: "#F4EFFF",
    borderRadius: 20,
    marginLeft: "3rem",
    width: "23rem",
    height: "3rem",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
    color: "#454C96",
    "&:hover": {
      backgroundColor: "#454C96",
      color: "#ffffff",
    },
  },
  label: {
    backgroundColor: "#908DF2",
    color: "#fff",
    padding: 5,
    borderRadius: 5,
  },
  checkbox: {
    width: "40px",
    height: "40px",
    marginTop: "55px",
    marginRight: "20px",
    "& .MuiSvgIcon-root": {
      width: "40px",
      height: "40px",
    },
    color: "#CED2D6",
    "&.Mui-checked": {
      color: "#908DF2",
    },
  },
  hrConfirmBtnContainer: {
    display: "flex",
    justifyContent: "center",
    paddingTop: "4rem",
    flexDirection: "column",
    alignItems: "center",
  },
  hrConfirmBtn: {
    padding: "10px 120px",
    borderRadius: "12px",
  },
  leftButton: {
    backgroundColor: "#908DF2",
    margin: theme.spacing(1, 0),
    width: "12rem",
  },
  printButton: {
    margin: theme.spacing(1, 0),
    width: "12rem",
  },
  printButtonMedia: {
    width: "20px",
    height: "20px",
    margin: "5px",
    objectFit: "contain",
  },
  pageBreak: {
    pageBreakBefore: "always",
    breakBefore: "page",
    breakInside: "avoid",
  },
}));
